import styled from 'styled-components'

const Columns1 = styled.div`
  display: flex;
  padding: 20px 30px 30px 30px;
`

const Columns2 = styled.div`
  display: flex;
  padding: 0px 30px 30px 30px;
`

const Column = styled.div`
  margin-right: 30px;
  width: 230px;
`

export const s = { Columns1, Columns2, Column }
